export const ACCOUNT_ID = "accountDetailId";
export const PAYMENT_TYPE = "paymentType";
export const ZELLE_URL = "zelleUrl";
export const ACH_ROUTING = "achRouting";
export const ACH_ACCOUNT = "achAccount";
export const ACH_ACCOUNT_NAME = "achAccountName";
export const ACH_BANK_NAME = "achBankName";
export const E_ACCOUNT_NO = "eaccountNumber";
export const E_ACCOUNT_NAME = "eaccountName";
export const E_ACCOUNT_EMAIL = "eaccountEmail";
export const E_ACCOUNT_PHONE = "eaccountPhone";
export const E_COM_SIGNUP = "ecomSignup";
export const E_COM_START_DATE = "ecomStartDate";
export const AUTO_BILLING_ENROLL = "autoBillingEnrolled";
export const AUTO_BILLING_START_DATE = "autoBillingEnrolledDate";
export const AUTO_BILLING_LA = "autoBillingForLeaseAdmin";
export const AUTO_BILLING_LA_START_DATE = "autoBillingStartDate";
export const AUTO_BILLING_LA_END_DATE = "autoBillingEndDate";

export const PAYMENT_TYPE_OPTIONS = [
  { label: "Zelle", value: "ZELLE" },
  { label: "ACH", value: "ACH" },
  // { label: "E-Check", value: "E_CHECK" },
  // { label: "Debit Card", value: "DEBIT_CARD" },
  // { label: "Credit Card", value: "CREDIT_CARD" },
  // { label: "Bank Transfer", value: "BANK_TRANSFER" },
];
